import { JSX, useState, useEffect } from 'react'

import { useListCollection, For, Portal } from '@chakra-ui/react'
// eslint-disable-next-line no-duplicate-imports
import { HStack, Spinner, Span, Combobox, ComboboxRootProps } from '@chakra-ui/react'

import * as detective from '@/lib/detective.js'




export type TItem = {
	value: string
	label: string

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Default
(
	props: {
		value: null | string
		change(value: null | string): void

		fit(value: string): Promise<string>
		search(value: string): Promise<TItem[]>

		placeholder?: string
		required?   : boolean

	},

)
:	JSX.Element
{
	let [label, update_label] = useState('')

	let [loading, update_loading] = useState(false)

	// eslint-disable-next-line @stylistic/function-call-spacing
	let data = useListCollection<TItem>
	(
		{
			// eslint-disable-next-line @typescript-eslint/naming-convention
			initialItems: [],

		},

	)


	let fit = async (): Promise<void> =>
	{
		if (detective.is_empty(props.value) )
		{
			data.set([])

			return

		}

		try
		{
			let v = await props.fit(props.value)

			update_label(v)

			data.set(
				[
					{ value: props.value, label: v },

				],

			)

		}

		catch
		{
			data.set([])

		}

	}

	let search = async (keyword: string): Promise<void> =>
	{
		update_loading(true)

		try
		{
			data.set(await props.search(keyword) )

		}
		catch
		{
			data.set([])

		}


		update_loading(false)


	}


	let on_select: ComboboxRootProps['onSelect'] = e =>
	{
		if (e.itemValue === props.value)
		{
			return

		}

		props.change(e.itemValue)

	}

	let on_search: ComboboxRootProps['onInputValueChange'] = e =>
	{
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		search(e.inputValue)

	}


	useEffect(
		() =>
		{
			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			fit()

		},

		[props.value],

	)


	return (
		<Combobox.Root
			lazyMount
			openOnClick
			alwaysSubmitOnEnter
			variant="flushed"
			inputValue={label}
			collection={data.collection}
			value={detective.is_empty(props.value) ? [] : [props.value]}
			onSelect={on_select}
			onInputValueChange={on_search}

		>
			<Control clearable={props.required !== true} placeholder={loading ? '加载中...' : props.placeholder} />

			<Portal>
				<Positioner loading={loading} value={data.collection.items} />

			</Portal>

		</Combobox.Root>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Control
(
	props: {
		clearable   : boolean
		placeholder?: string

	},

)
:	JSX.Element
{
	return (
		<Combobox.Control>
			<Combobox.Input
				fontSize="xl"
				fontWeight="inherit"
				color="fg.muted"
				placeholder={props.placeholder ?? '无'}
			/>

			<Combobox.IndicatorGroup>
				<Combobox.Trigger />

				{props.clearable && <Combobox.ClearTrigger />}

			</Combobox.IndicatorGroup>

		</Combobox.Control>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Loading (): JSX.Element
{
	return (
		<HStack p="2">
			<Spinner size="xs" borderWidth="1px" />
			<Span>加载中...</Span>

		</HStack>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function TItem
<T extends TItem> (props: { value: T }): JSX.Element
{
	return (
		<Combobox.Item item={props.value}>
			<Span fontWeight="medium" truncate>
				{props.value.label}

			</Span>

			<Combobox.ItemIndicator />

		</Combobox.Item>

	)


}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Items
<T extends TItem> (props: { value: T[] }): JSX.Element
{
	return (
		<For each={props.value}>
			{v => <TItem key={`${v.label}.${v.value}`} value={v} />}

		</For>

	)


}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Positioner
<	T extends TItem	>
(
	props: {
		loading: boolean

		value  : T[]

	},

)
:	JSX.Element
{
	return (
		<Combobox.Positioner>
			<Combobox.Content scrollbarWidth="thin" scrollBehavior="smooth">
				{ props.loading ? <Loading /> : <Items value={props.value} /> }

			</Combobox.Content>

		</Combobox.Positioner>

	)

}
